/* eslint-disable @typescript-eslint/no-explicit-any */
//Mainly needed for UT as this cannot be mocked otherwise. accountConfigNative is defined in native bridge code.

export default window.accountConfigNative;
